import React, { useState } from 'react';
import ActivityLoader from '../../Common/ActivityLoader';
import BsModal from '../../Common/BsModal';
import { useConfig } from '../../../DataStore/ConfigContext';
import ajaxConfig from '../../../util/remote/ajaxConfig';
import { useTheme } from '../../../DataStore/ThemeContext';
import Notification from '../../Common/Notification';

const AlertDeletePaper = () => {

    const [loading, setLoading] = useState(false);
    const {setNotify} = useTheme();

    const { deletePaper, setDeletePaper } = useConfig();

    const handleClose = () => setDeletePaper({ show: false, paper: null });


   if (!deletePaper.paper) return null;
  
   

    const confirm = async()=>{
        setLoading(true);
        const server_response = await ajaxConfig.deletePaper(deletePaper.paper.paper_id);
        setLoading(false);
        if(server_response.status === "OK"){
            deletePaper.callback();
            setNotify(<Notification type='success' message={server_response.message}/>)
        }else{
            setNotify(<Notification type='danger' message={server_response.message}/>)

        }
        handleClose();
    }

    return (
        <BsModal
            show={deletePaper.show}
            onClose={handleClose}
            title="Delete Subject Paper"
            footer={
                <>
                    {loading && <ActivityLoader />}
                    {!loading && <>
                    <button className="btn btn-secondary" onClick={handleClose}>
                        Cancel
                    </button>
                    <button className="btn btn-danger" onClick={confirm}>
                        Confirm Delete
                    </button>
                    </>}
                </>
            }
        >


            {deletePaper.paper && <div className="d-flex justify-content-center align-items-center flex-column">
                <i 
                className="fa fa-question-circle text-danger" 
                style={{ fontSize: "40px", lineHeight: "1", marginTop: "20px" }}
                ></i>
                <h5 className='mt-1 text-dark text-center' style={{fontSize: '17px'}}>Please confirm that you want to delete this subject paper, <i>{deletePaper.paper.paper_code}</i>.</h5>

                <p className="mb-4 mt-2 text-secondary">
                <b>Note: </b>Make sure subject paper has no students marks.
                </p>
           
            </div>}
          

        </BsModal>
    );
};

export default AlertDeletePaper;
